export default {
  currentModal(state, getters, rootState) {
    return rootState.global.modal.current;
  },
  totalCartAmount(state) {
    return state.cart.total_price;
  },
  isCartEmpty(state) {
    return state.cart.items.length === 0;
  },
  gwpType(state) {
    return state.gwp.thresholds?.length ? 'threshold' : 'collection';
  },
  gwpThresholds(state) {
    return state.gwp.thresholds;
  },
  isGWPLoading(state) {
    return state.gwp.loading;
  },
  isGWPActive(state) {
    return state.gwp.active;
  },
  isGWPLayoutActive(state) {
    return state.gwp.layout;
  },
  isOnlyOneProductGWP(state) {
    return state.gwp.onlyOneProduct;
  },
  totalCartGWPAmount(state) {
    const excludedProductTypes = ['Gift Cart', 'Gift Card', 'Donation'];
    const excludedProductTotal = state.cart.items.reduce((acc, item) => {
      return (
        acc +
        (excludedProductTypes.includes(item.product_type) ||
        item.properties?._is_gwp
          ? item.line_price
          : 0)
      );
    }, 0);
    return state.cart.total_price - excludedProductTotal;
  },
  GWPProducts(state) {
    return state.gwp.collection;
  },
  GWPRewardProducts(state) {
    return state.gwp.rewardCollection;
  },
  GWPHandle(state) {
    return state.gwp.rewardHandle;
  },
  productsWithSubscription(state) {
    return state.cart.items
      .map((p) => {
        if (p.selling_plan_allocation?.selling_plan?.id) {
          return {
            id: p.id,
            selling_plan: p.selling_plan_allocation.selling_plan.id,
          };
        }
        return false;
      })
      .filter((id) => id !== false);
  },
  cartHasGWPProducts(state) {
    let res = false;
    if (state.gwp.collection) {
      const cartIds = state.cart.items.map(
        (i) => i.product_id || (i.id && i.properties._is_gwp),
      );
      if (cartIds.length > 0) {
        const productsFromCollectionInsideCart = state.gwp.collection.filter(
          (i) => {
            return cartIds.includes(parseInt(i.id));
          },
        );
        if (productsFromCollectionInsideCart.length > 0) {
          res = true;
        }
      }
    } else {
      const gwpItems = state.cart.items?.reduce((acc, rec) => {
        if (rec.properties._is_gwp) {
          return (acc += rec.quantity);
        }
        return acc;
      }, 0);
      if (!!gwpItems) return true;
    }
    return res;
  },
  GWPApplicableProducts(state) {
    let res = 0;
    if (state.gwp.collection && state.cart.items.length) {
      state.cart.items.forEach((item) => {
        if (item.properties?._is_gwp) {
          return;
        }

        const matchingProduct = state.gwp.collection.find((el) => {
          const gwpVariant = el.variants.find((variant) =>
            parseInt(variant.id) === parseInt(item.id) ||
            parseInt(variant.id) === parseInt(item.variant_id)
          );
          return !!gwpVariant;
        });

        if (matchingProduct) {
          res += item.quantity;
        }
      });
    }
    return res;
  },
  gwpCollectionData(state) {
    return state.gwp.collection_data;
  },
  rewardIsOnlyOneProduct(state) {
    return state.gwp.rewardCollection.length === 1;
  },
  rewardProducts(state) {
    return state.gwp.rewardCollection;
  },
  rewardProductsAvailable(state) {
    return state.gwp.rewardCollection
      ? state.gwp.rewardCollection.filter((s) => s.available)
      : [];
  },
  rewardProductsLimit(state, getters) {
    return Math.min(
      state.gwp.rewardLimit,
      getters.rewardProductsAvailable.length,
    );
  },
  rewardUserList(state, getters) {
    return [
      ...new Set([
        ...state.gwp.userSelection,
        ...getters.gwpAlreadyAddedToCart,
        ...state.gwp.userAltSelection.map((p) => parseInt(p.id)),
      ]),
    ];
  },
  replaceProducts(state) {
    const res = state.gwp.userAltSelection;
    const altProducts = state.cart.items
      .filter((p) => p.properties._gwp_original_shadow)
      .forEach((p) => {
        let original = parseInt(p.properties._gwp_original_shadow);
        let id = parseInt(p.properties._gwp_prev_shadow);
        if (isNaN(original)) {
          original = p.product_id;
        }
        if (isNaN(id)) {
          id = p.id;
        }
        res.push({
          id,
          original,
          title: p.variant_title,
          properties: p.properties,
        });
      });
    return res;
  },
  rewardUserListNotAdded(state, getters) {
    const res = [];
    state.gwp.userSelection.forEach((id) => {
      res.push({ id: id });
    });
    state.gwp.userAltSelection.forEach((p) => {
      const data = {
        id: p.id,
        original: p.original,
      };
      if (p.properties) {
        data.properties = p.properties;
      }
      res.push(data);
    });
    return res;
  },
  rewardUserProductsLeft(state, getters) {
    return getters.rewardProductsLimit - getters.rewardUserList.length;
  },

  userSelectionReady(state, getters) {
    return getters.isGWPLayoutActive
      ? getters.rewardUserList.length >= getters.rewardProductsLimit
      : false;
  },
  gwpAlreadyAddedToCart(state) {
    return state.cart.items
      .filter((el) => el.properties._is_gwp)
      .map((el) => parseInt(el.id));
  },
  gwpAlreadyAltAddedToCart(state) {
    return state.cart.items.filter((el) => el.properties._is_gwp);
  },

  cartLineByVariantId:
    (state) =>
    ({ id, isBundle = false, properties = {}, isEditable = false }) => {
      const bundleUid = properties?._bundle_uid ?? null;
      if (!isBundle && bundleUid) isBundle = true;

      if (isEditable) {
        return state.cart.items.find((i) => `${i.id}` === `${id}`);
      }

      return state.cart.items.find(
        (i) =>
          `${i.id}` === `${id}` &&
          ((typeof i.properties?._bundle_uid !== 'undefined' &&
            isBundle &&
            bundleUid === i.properties._bundle_uid &&
            parseInt(properties._bundle_index) ===
              parseInt(i.properties._bundle_index)) ||
            (typeof i.properties?._bundle_uid === 'undefined' && !isBundle)),
      );
    },

  cartLineByProperties:
    (state) =>
    (props, items = null) => {
      items = items ?? state.cart.items;
      return items.find((i) => {
        let match = true;
        Object.keys(props).forEach((key) => {
          if (
            typeof i.properties?.[key] === 'undefined' ||
            i.properties?.[key] !== props[key]
          ) {
            match = false;
          }
        });
        return match;
      });
    },

  // ============================================================================
  // METAOBJECT-BASED PROMOTIONS GETTERS
  // ============================================================================

  promotionsLoaded(state) {
    return state.promotions.loaded;
  },
  promotionsLoading(state) {
    return state.promotions.loading;
  },
  activeGWPPromotions(state) {
    return state.promotions.gwp;
  },
  hasActiveGWPPromotion(state) {
    return state.promotions.gwp.length > 0;
  },
  activeSamplePromotion(state) {
    return state.promotions.samples[0] || null;
  },
  activeSamplePromotions(state) {
    return state.promotions.samples;
  },
  /**
   * Sample promotion config for UI consumption
   * @returns {Object} Sample config with threshold, quantity, products, display fields
   */
  sampleConfig(state) {
    const promo = state.promotions.samples[0];

    if (!promo) {
      return {
        active: false,
        threshold: 0,
        quantity_allowed: 0,
        products: [],
        title: '',
        copy: '',
      };
    }

    const normalizedProducts = (promo.products || [])
      .filter(p => {
        const isSample = p.tags?.includes('sample');
        const isAvailable = p.availableForSale !== false;
        const isFree = parseFloat(p.priceRange?.minVariantPrice?.amount || 0) === 0;
        return isSample && isAvailable && isFree;
      })
      .map(p => {
        const delimiter = window.__GLOBAL__?.productDelimiter || ' - ';
        const titleParts = (p.title || '').split(delimiter);
        return {
          id: p.id,
          handle: p.handle,
          title: p.title,
          productTitle: titleParts[0]?.trim() || p.title,
          shadeTitle: titleParts[1]?.trim() || '',
          variantId: p.variants?.edges?.[0]?.node?.id?.replace('gid://shopify/ProductVariant/', '') || null,
          image: p.featuredImage?.url || null,
          imageAlt: p.featuredImage?.altText || p.title,
          available: p.availableForSale !== false,
          sampleColors: p.sampleColors?.value?.split(',').map(c => c.trim()) || [],
          tags: p.tags || [],
        };
      });

    return {
      active: true,
      threshold: parseInt(promo.threshold, 10) || 0,
      quantity_allowed: parseInt(promo.quantity_allowed, 10) || 1,
      products: normalizedProducts,
      title: promo.title || promo.name || '',
      copy: promo.copy || '',
      start_date: promo.start_date || null,
      end_date: promo.end_date || null,
    };
  },
  getGWPPromotionByCode: (state) => (code) => {
    return state.promotions.gwp.find(
      (promo) => promo.handle === code || promo.name === code
    ) || null;
  },
  gwpPromotionThresholds(state) {
    const thresholds = [];

    state.promotions.gwp.forEach((promo) => {
      const tiers = promo.tiers;

      if (tiers && Array.isArray(tiers) && tiers.length > 0) {
        tiers.forEach((tier) => {
          thresholds.push({
            code: tier.name || promo.exclusive_filter || promo.name || promo.handle,
            value: parseInt(tier.threshold, 10) || 0,
            tier_key: tier.handle || tier.id,
            product_list: tier.product_list || [],
            quantity: parseInt(tier.limit, 10) || 1,
            name: tier.name || promo.name,
            _promo: promo,
            _tier: tier,
          });
        });
      }
      else if (promo.threshold || promo.product_list) {
        thresholds.push({
          code: promo.exclusive_filter || promo.name || promo.handle,
          value: parseInt(promo.threshold, 10) || 0,
          tier_key: promo.handle || promo.id,
          product_list: promo.product_list || [],
          quantity: parseInt(promo.limit, 10) || 1,
          name: promo.name,
          _promo: promo,
        });
      }
    });

    return thresholds.sort((a, b) => a.value - b.value);
  },
  gwpConfig(state, getters) {
    const thresholds = getters.gwpPromotionThresholds;
    const hasPromotions = thresholds.length > 0;
    const firstPromo = state.promotions.gwp[0];

    const firstTier = firstPromo?.tiers?.[0];
    const isCollectionType = !!(firstTier?.qualifying_product_list?.length && firstTier?.min_products_required);
    const promoType = isCollectionType ? 'collection' : 'threshold';

    const qualifyingProductList = firstTier?.qualifying_product_list || [];
    const giftProductList = firstTier?.product_list || [];
    const minProductsRequired = firstTier?.min_products_required;
    const giftLimit = firstTier?.limit;
    const imageCollection = firstPromo?.image_collection?.url || firstPromo?.image_collection || null;

    return {
      active: hasPromotions || isCollectionType,
      type: promoType,
      thresholds: thresholds,
      qualifying_product_list: qualifyingProductList,
      gift_product_list: giftProductList,
      collection_min_quantity: parseInt(minProductsRequired, 10) || 1,
      gift_collection_limit: parseInt(giftLimit, 10) || 1,
      promo_message: firstTier?.promo_message || '',
      select_label: firstTier?.select_label || '',
      text_color: firstPromo?.text_color || '#C35C66',
      background_color: firstPromo?.background_color || '#ffffff',
      gwp_button_text_color: firstPromo?.button_text_color || '#ffffff',
      gwp_button_background: firstPromo?.button_background || '#000000',
      image: firstPromo?.image?.url || firstPromo?.image || null,
      image_collection: imageCollection,
      filter_code: firstPromo?.exclusive_filter || '',
      message: firstPromo?.message || '',
      countries: firstPromo?.countries || '',
    };
  },
  qualifyingGWPPromotion(state, getters) {
    const cartTotal = getters.totalCartGWPAmount;
    const thresholds = getters.gwpPromotionThresholds;

    const qualifying = thresholds
      .filter((t) => cartTotal >= t.value)
      .pop();

    return qualifying || null;
  },
  nextGWPTier(state, getters) {
    const cartTotal = getters.totalCartGWPAmount;
    const thresholds = getters.gwpPromotionThresholds;

    return thresholds.find((t) => cartTotal < t.value) || null;
  },
  amountToNextGWPTier(state, getters) {
    const cartTotal = getters.totalCartGWPAmount;
    const nextTier = getters.nextGWPTier;

    if (!nextTier) return 0;
    return Math.max(0, nextTier.value - cartTotal);
  },
  qualifyingSamplePromotion(state, getters) {
    const cartTotal = getters.totalCartGWPAmount / 100;
    const samplePromo = getters.activeSamplePromotion;

    if (!samplePromo) return null;

    const threshold = parseInt(samplePromo.threshold, 10) || 0;
    return cartTotal >= threshold ? samplePromo : null;
  },
};
